<div class="todos-container">
  <div class="todos-header">
    <span rtI18n>To Dos</span>
    @if (todoCount > 0) {
      <span class="todos-count">{{todoCount}}</span>
    }
  </div>
  @if (status === ServiceStatus.loading || status === ServiceStatus.unset) {
    <div class="loading-outer">
      <mat-spinner class="spinner" [diameter]="30"></mat-spinner>
    </div>
  }
  <div class="todo-cards-scroll">
    <div class="todo-cards-list">
      @if (!showReenrollment && cards.length === 0) {
        <div class="text-text-blue" rtI18n>You're all caught up!</div>
      }
      <!-- Replaces the portal's home-page re-enrollment banner: same window + Enrolled-student
            rules, shown as the first To Do instead of a banner. Routes to the portal's form. -->
      @if (showReenrollment) {
        <a class="todo-card card reenrollment-card" [href]="reenrollmentUrl" target="_blank" rel="noopener noreferrer"
           (click)="portalLink.interceptAnchorClick($event, reenrollmentUrl)">
          <div class="todo-icon-circle"><i class="icon-school icon-action-blue"></i></div>
          <div class="todo-body">
            <div class="todo-title" rtI18n>Confirm your family's return for next school year!</div>
            <div class="todo-subtitle" rtI18n>Secure your spot and share your intent to return.</div>
            <span class="btn btn-header btn-small reenroll-btn" rtI18n>Review Your Plans</span>
          </div>
        </a>
      }
      @for (card of cards; track $index) {
        @switch (card.kind) {
          @case ('form') {
            <a class="todo-card card" [href]="card.link" target="_blank" rel="noopener noreferrer"
               (click)="portalLink.interceptAnchorClick($event, card.link ?? null)">
              <div class="todo-icon-circle icon-circle-blue"><i class="icon-form icon-action-blue"></i></div>
              <div class="todo-body">
                @if (card.formsKind === 'required') {
                  <div class="todo-title" rtI18n [rtI18nParams]="{ year: card.yearLabel }">Required forms [[year]]</div>
                } @else {
                  <div class="todo-title" rtI18n [rtI18nParams]="{ year: card.yearLabel }">Enrollment registration forms [[year]]</div>
                }
                <div class="todo-subtitle">{{card.studentFirstName}} &middot; {{card.schoolName}}</div>
                <div class="todo-progress">
                  <div class="todo-progress-track">
                    @for (seg of range(card.totalForms ?? 0); track seg) {
                      <div class="todo-progress-segment" [class.filled]="seg < (card.formsCompleted ?? 0)"></div>
                    }
                  </div>
                  <span class="todo-progress-count" [class.has-progress]="(card.formsCompleted ?? 0) > 0">{{card.formsCompleted}}/{{card.totalForms}}</span>
                </div>
              </div>
            </a>
          }
          @case ('vop') {
            <!-- School-level survey (no student); external link, disabled while impersonating. -->
            @if (isImpersonating) {
              <div class="todo-card card disabled">
                <div class="todo-icon-circle icon-circle-blue"><i class="icon-comment icon-action-blue"></i></div>
                <div class="todo-body">
                  <div class="todo-title">{{card.title | translate}}</div>
                  <div class="todo-subtitle">{{card.schoolName}}</div>
                </div>
              </div>
            } @else {
              <a class="todo-card card" [href]="card.link" target="_blank" rel="noopener noreferrer">
                <div class="todo-icon-circle icon-circle-blue"><i class="icon-comment icon-action-blue"></i></div>
                <div class="todo-body">
                  <div class="todo-title">{{card.title | translate}}</div>
                  <div class="todo-subtitle">{{card.schoolName}}</div>
                </div>
              </a>
            }
          }
          @default {
            <!-- Fallback for todo types this app has no dedicated card for yet. -->
            <div class="todo-card card static">
              <div class="todo-icon-circle icon-circle-orange"><i class="icon-calendar icon-orange"></i></div>
              <div class="todo-body">
                <div class="todo-title">{{card.title | translate}}</div>
                <div class="todo-subtitle">{{card.message | translate}}</div>
              </div>
            </div>
          }
        }
      }
    </div>
  </div>
</div>

